import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { url } from './constants';

export const canActivate: CanActivateFn = () => {
  const loginService = inject(LoginService);
  const router = inject(Router)

  if (loginService.isLogged()) {
    return true;
  } else {
    router.navigate([url['login']]);
    return false;
  }
};

export const canActivateAdmin: CanActivateFn = () => {
  const loginService = inject(LoginService);
  const router = inject(Router)

  if (loginService.isAdminLogged()) {
    return true;
  } else {
    router.navigate([url['home']]);
    return false;
  }
};
